// Invoices feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.invoices.*`) intézi; a kulcsok itt élnek (cache-egységesítés). A `@atlas/contracts`
// a szerződés forrás-igazsága — itt csak kulcs-logika van (a clients/accounts/tickets feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `sort` a rendezés-KULCS (issueDate | dueDate | invoiceNumber | issuerName | grossTotal), az `order` az
 *  irány; a `q` (számlaszám-keresés) és a `status` a toolbar-szűrők. */
export interface InvoiceListFilters {
  q: string;
  status: string;
  issuer: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** A generálási kihagyás-napló lista-lekérdezésének szűrői (a `GET /invoices/generation-skips` query-tükre). */
export interface InvoiceGenerationSkipListFilters {
  month: string;
  reason: string;
  clientId: string;
  q: string;
  /** `open` (alap) · `resolved` · `all` — a nyitott/lezárt tengely (a cache-t is ez particionálja). */
  state: string;
}

/** Query-kulcs gyár — a lista/detail/refs cache egységes címzése (invalidálás + a szerkesztő). */
export const invoiceKeys = {
  all: ['invoices'] as const,
  lists: () => ['invoices', 'list'] as const,
  list: (filters: InvoiceListFilters) => ['invoices', 'list', filters] as const,
  detail: (id: string) => ['invoices', 'detail', id] as const,
  /** A szerkesztő-picker (refs) — a cache-t a választott ügyfél particionálja (accounts/billingProfiles). */
  refs: (clientId: string) => ['invoices', 'refs', clientId] as const,
  /** A „Generálási kihagyások" fül MINDEN cache-e (lista + fül-darabszám) — PREFIX-invalidáláshoz. */
  generationSkipsAll: () => ['invoices', 'generation-skips'] as const,
  /** A „Generálási kihagyások" fül listája (`billing/invoice-generation-skips` napló). */
  generationSkips: (filters: InvoiceGenerationSkipListFilters) =>
    ['invoices', 'generation-skips', filters] as const,
};
